<template>
  <div class="extended-forms">
    <div class="card">
        <div class="card-body" style="padding-top: 0">
            <div class="row">

                <div class="col-md-2">
                    <h4 style="margin-top:0" class="card-title">Desde</h4>
                    <div class="form-group">
                    <el-date-picker
                        v-model="dateFrom"
                        type="date"
                        placeholder="  Seleccionar un dia"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                    </div>
                </div>

                <div class="col-md-2">
                    <h4 style="margin-top:0" class="card-title">Hasta</h4>
                    <div class="form-group">
                    <el-date-picker
                        v-model="dateTo"
                        type="date"
                        placeholder="  Seleccionar un dia"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                    </div>
                </div>

                <div class="col-md-4">
                    <h4 style="margin-top:0" class="card-title">Vehículo</h4>
                    <fg-input v-if="this.vehiculosDisponibles">
                    <multiselect
                        v-model="multiSelectValue"
                        :options="vehiculos"
                        :multiple="true"
                        :searchable="true"
                        :close-on-select="true"
                        :show-labels="true"
                        group-values="grupoVeh"
                        group-label="name"
                        :group-select="true"
                        placeholder="Ingrese un dominio"
                        deselectGroupLabel="Presione para deseleccionar el Grupo"
                        deselectLabel="Presione para deseleccionar el vehículo"
                        selectedLabel="Seleccionado"
                        selectGroupLabel="Presione para seleccionar el Grupo"
                        selectLabel="Presione para seleccionar el vehículo"
                        track-by="pat"
                        label="pat"
                        :value="multiSelectCurrentVal"
                        :max-height="300"
                    >
                        <span slot="noResult">No se encontró ningún vehículo..</span>
                    </multiselect>
                    </fg-input>
                </div>

                <div class="col-md-1">
                    <p-button
                    class="form-buttons report-buttons"
                    type="neutral"
                    round
                    @click="updateTable()"
                    > <i class="nc-icon nc-refresh-69" style="font-size: 2.5em;"></i>
                      <p style=" padding-top: 15px; margin-bottom: 0px; font-size: 1.1em;">Actualizar</p>
                    </p-button>
                </div>

                <div class="col-md-1">
                    <p-button
                    class="form-buttons report-buttons"
                    type="neutral"
                    round
                    @click="openSweet()"
                    > <i class="nc-icon nc-cloud-download-93" style="font-size: 2.5em;"></i>
                      <p style=" padding-top: 15px; margin-bottom: 0px; font-size: 1.1em;">Descargar</p>
                    </p-button>
                </div>
                <div class="col-md-1">
                    <p-button
                    class="form-buttons report-buttons"
                    type="neutral"
                    round
                    @click="heatMap()"
                    > <i class="nc-icon nc-map-big" style="font-size: 2.5em;"></i>
                      <p style=" padding-top: 15px; margin-bottom: 0px; font-size: 1.1em;">HeatMap</p>
                    </p-button>
                </div>
            </div> <!--  row -->
        </div>
    </div>

    <div id="modalReports"></div>
        <div class="card">
        <div class="card-content table-responsive table-full-width" style="overflow: hidden;">
        <el-table
          :data="total"
          style="overflow: hidden;"
          :show-header="false"
        >
          <el-table-column>
            <template @click="sortBy()" slot-scope="scope"><b>TOTALES</b></template>
          </el-table-column>

           <el-table-column>
            <template slot-scope="scope"><b>  </b></template>
          </el-table-column>

          <el-table-column>
            <template slot-scope="scope"><b>{{Math.floor(scope.row.distance/1000)}} Km</b></template>
          </el-table-column>

          <el-table-column>
            <template slot-scope="scope"><b>{{scope.row.travel}}</b></template>
          </el-table-column>

          <el-table-column>
            <template slot-scope="scope"><b>{{scope.row.stopped}}</b></template>
          </el-table-column>

          <el-table-column>
            <template slot-scope="scope"><b>{{scope.row.vmax}} Km/h</b></template>
          </el-table-column>

          <el-table-column>
            <template slot-scope="scope"></template>
          </el-table-column>
        </el-table>
      </div>

    </div>


    <div class="card">

      <div class="card-content table-responsive table-full-width" style="overflow: hidden; padding-bottom: 14px;">
        <el-table
          stripe
          :data="tableData"
          style="overflow: hidden;"
          :cell-style="{padding: '2px', height: '20px'}"
          :row-class-name="WeekendDays"
        >
          <el-table-column onclick="alert();" label="Fecha">
            <template @click="sortBy()" slot-scope="scope">{{ d = changeFormatDay(scope.row.log_rep_date)}}</template>
          </el-table-column>

           <el-table-column style="color:red;" onclick="alert();" label="Día">
            <template @click="sortBy()" slot-scope="scope">{{ scope.row.log_week_day }}</template>
          </el-table-column>

          <el-table-column label="Distancia">
            <template slot-scope="scope">{{Math.floor(scope.row.log_rep_distance/1000)}} Km</template>
          </el-table-column>

          <el-table-column label="En Viaje">
            <template slot-scope="scope">{{scope.row.log_rep_trip_time}}</template>
          </el-table-column>

          <el-table-column label="Parado">
            <template slot-scope="scope">{{scope.row.log_rep_stop_time}}</template>
          </el-table-column>

          <el-table-column label="Vel. Máx">
            <template slot-scope="scope">{{scope.row.log_rep_max_speed}} Km/h</template>
          </el-table-column>

          <el-table-column
            class-name="action-buttons td-actions"
            align="right"
            label="Acciones">
              <template slot-scope="props">
                <p-button type="neutral" size="sm" icon @click="goToStoryMap(props.$index, props.row)">
                  <i class="nc-icon nc-pin-3" style="font-size: 1em; padding-top: 0.1em;"></i>
                </p-button>
                <p-button type="neutral" size="sm" icon @click="showDetail(props.row)">
                  <i class="nc-icon nc-bullet-list-67" style="font-size: 1em; padding-top: 0.1em;"></i>
                </p-button>
                <p-button type="neutral" size="sm" icon @click="downloadDetail(props.row)">
                  <i class="nc-icon nc-cloud-download-93" style="font-size: 1em; padding-top: 0.1em;"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from "vue";

import swal from "sweetalert2";
import { DatePicker, Select, Option, Tag, Button, Card } from "element-ui";
import PSwitch from "src/components/UIComponents/Switch.vue";
import { mapState } from "vuex";
import vehiculoService from "../../../services/vehiculo";
import store from "../../../store";
import { Table, TableColumn } from "element-ui";
import ReporteService from "../../../services/reporte";
import { ConfigParams } from "../../../config.js";
import Multiselect from "vue-multiselect";

Vue.use(Table);
Vue.use(TableColumn);

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Option.name]: Option,
    [Select.name]: Select,
    PSwitch,
    Multiselect
  },
  computed: {
    ...mapState(["grupos"])
  },
  data() {
    return {
      d: '',
      day: '',
      totalReady: false,
      search: "",
      multiSelectValue: "",
      multiSelectCurrentVal: "",
      tableData: [],
      total: [{
        distance: '',
        travel: '',
        stopped: '',
        vmax: ''
      }],
      pickerOptions: {
        shortcuts: [
          {
            text: "Hoy",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "Ayer",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "Sem. pasada",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      dateFrom: "",
      dateTo: "",
      vehiculos: [],
    //   vehiculosSeleccionados: [],
      vehiculosDisponibles: false,
      vehiculoSeleccionado: ""
    };
  },
  mounted() {
    this.getVehiculos();
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    //TODO: Revisar y mejorar este mecanismo de preservación del estado de la consulta
    this.tableData = this.$store.state.detalleReporte.tableData
    this.dateFrom = this.$store.state.detalleReporte.fechaDesde
    this.dateTo = this.$store.state.detalleReporte.fechaHasta
    this.multiSelectValue = this.$store.state.detalleReporte.vehiculos
    if (this.tableData.length > 0) {
      this.calculateTotal()
    }

  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    // this.totalReady = false
  },
  methods: {

    // onChange(value) {
    //   this.vehiculoSeleccionado = value[0].pat;
    //   this.vehiculosSeleccionados[0] = value[0].pat;
    // },
    WeekendDays({row, rowIndex}) {

        // let day = his.showNameDay(row.log_rep_date)
        if (row.log_week_day === "Sab" || row.log_week_day === "Dom") {
            return 'weekend-day'
        }
     },

    showNameDay(value){
        let days = ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'];
        let current_datetime = (new Date(value)).getDay();
        return days[current_datetime];
    },

    changeFormatDay(value){

        var iniDate = new Date(value);

        return iniDate.toISOString().substring(8, 10)
                +iniDate.toISOString().substring(4, 8)
                +iniDate.toISOString().substring(0, 4);

        // var current_datetime = new Date(value);
        // var day = current_datetime.getDate() + 1
        // var month = current_datetime.getMonth() + 1
        // var year = current_datetime.getFullYear()

        // if(day < 10) {
        //   day = "0" + day;
        // }

        // if(month < 10) {
        //   month = "0" + month
        // }

        // if( (month == '04' || month == '06' || month == '09' || month == '11' ) && day == 31){

        //     var month = current_datetime.getMonth() + 2
        //     day = '01'
        // }

        // if( (month == '01' || month == '05' || month == '07' || month == '08' || month == '10' || month == '12' ) && day == 32){

        //     var month = current_datetime.getMonth() + 2
        //     month = "0" + month
        //     day = '01'
        // }

        // let formatted_date = day + "-" + month + "-" + year
        // return formatted_date;
    },

    heatMap(index, row){

      this.$store.commit("setDetalleReporte", {
        patente: this.multiSelectValue[0].pat,
        tableData: this.tableData,
        fechaDesde: this.dateFrom,
        fechaHasta: this.dateTo,
        vehiculos: this.multiSelectValue,
      });
      this.$router.push({ path: "heatmap" })
    },

    goToStoryMap(index, row){
      this.$store.commit('setStorymap' ,{
        fila: row
      })
      this.$store.commit("setDetalleReporte", {
        patente: row.veh_id,
        idReporte: row.log_rep_id,
        tableData: this.tableData,
        fechaDesde: this.dateFrom,
        fechaHasta: this.dateTo,
        vehiculos: this.multiSelectValue,
      });
      this.$router.push({ path: "storymap" })
    },

    showDetail(row) {
      this.$store.commit("setDetalleReporte", {
        patente: row.veh_id,
        idReporte: row.log_rep_id,
        tableData: this.tableData,
        fechaDesde: this.dateFrom,
        fechaHasta: this.dateTo,
        vehiculos: this.multiSelectValue,
      });
      this.$router.push({ path: "reportDetail" });
    },

    downloadDetail(row) {
        let urlxls =
            ConfigParams.API_REP_URL +
            "index.php?veh=" +
            row.veh_id +
            "&from=" +
            this.formatDate(row.log_rep_date) +
            "&to=" +
            this.formatDate(row.log_rep_date);

        urlxls += "&trip=full";
        urlxls += "&event=yes";
        urlxls += "&xval=" + ConfigParams.INDEX_KEY;

        window.open(urlxls, "_blank");
    },

    updateTable() {
      let desde = this.formatDate(this.dateFrom);
      let hasta = this.formatDate(this.dateTo);
      ReporteService.resumenRecorridos(this.multiSelectValue[0].pat, desde, hasta)
        .then(res => {
          res.data.forEach(element => {
              element.log_week_day = this.showNameDay(element.log_rep_date)
          });
          this.tableData = res.data;
          this.calculateTotal()
        });
    },

    formatDate(fecha) {

      let newdate = new Date(fecha)
      return newdate.toISOString().substring(0, 10);
    },

    formatTimeToSeconds(fecha) {
        var a = fecha.split(':');
        var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
        return seconds
    },

    formatSecondsToTime(seg) {

        if (seg >= 86400) {
          var d = Math.floor(seg / 86400);
          var h = Math.floor(seg % 86400 / 3600 )
        }
        else {
            var h = Math.floor(seg / 3600 )
        }

        if (h < 10) {
            h = "0"+ h
        }

        let m = Math.floor(seg % 3600 / 60);
        let s = Math.floor(seg % 3600 % 60);

        if (m < 10) {
            m = "0"+ m
        }
        if (s < 10) {
            s = "0"+ s
        }
        if (seg >= 86400) {
            var dhms = d + 'd ' + h + ':'+ m + ':' + s
            return dhms
        }

        let hms = h + ':'+ m + ':' + s

        return hms
    },

    getVehiculos() {
      vehiculoService.index().then(res => {
        this.$store.commit("setGrupos", {
          gruposVehiculos: res.data
        });
        this.formatData();
      });
    },

    formatData() {
      var i;
      var j;
      for (i = 0; i < this.grupos.length; i++) {
        var grupo = {
          name: this.grupos[i].grupo_nombre,
          grupoVeh: []
        };
        for (j = 0; j < this.grupos[i].grupos_vehiculos.length; j++) {
          var veHSel = {
            pat: this.grupos[i].grupos_vehiculos[j].veh_id,
            key: this.grupos[i].grupos_vehiculos[j].veh_id
          };
          grupo.grupoVeh.push(veHSel);
        }
        this.vehiculos.push(grupo);
      }
      this.vehiculosDisponibles = true;
    },

    calculateTotal() {
      let vmax = 0
      let distance = 0
      let travel = 0
      let stopped = 0
      for (let i = 0; i < this.tableData.length; i++) {
        distance = distance + this.tableData[i].log_rep_distance

        travel = travel + this.formatTimeToSeconds(this.tableData[i].log_rep_trip_time)
        stopped = stopped + this.formatTimeToSeconds(this.tableData[i].log_rep_stop_time)

        if (this.tableData[i].log_rep_max_speed > vmax) {
          vmax = this.tableData[i].log_rep_max_speed
        }
      }

      travel = this.formatSecondsToTime(travel)
      stopped = this.formatSecondsToTime(stopped)

      this.total[0].vmax = vmax
      this.total[0].distance = distance
      this.total[0].travel = travel
      this.total[0].stopped = stopped
      this.totalReady = true

    },

    handleResize() {
      let navbarHeight = document.getElementById("navbar").offsetHeight;
      let windowHeight = window.innerHeight;
      let contentHeight = windowHeight - navbarHeight;
      document.getElementById("content").style.height = contentHeight + "px";
      document.getElementById("sidebar").style.height = windowHeight + "px";
    },

    openSweet() {
      this.$store.commit("setReporte", {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        vehiculosSeleccionados: this.multiSelectValue
      });
      Vue.component("my-comp", {
        template: `
          <div class="card" style="box-shadow:none;">
            <div class="row" style="background: #e9ecef; border-bottom: none;">

              <div class="col-md-6">
                <card style="height: 300px;">
                  <h4 class="card-title">Planilla</h4>
                  <p-switch v-model="switchTrip.recorridos" type="primary" on-text="ON" off-text="OFF"></p-switch>
                  <span class="etiquetas">Recorridos</span>
                  <br />
                  <br />
                  <p-switch v-model="switchTrip.eventos" type="primary" on-text="ON" off-text="OFF"></p-switch>
                  <span class="etiquetas">Eventos &nbsp &nbsp &nbsp </span>
                  <br />
                  <br />
                  <p-switch v-model="switchTrip.velocidad" type="primary" on-text="ON" off-text="OFF"></p-switch>
                  <span class="etiquetas">Velocidad &nbsp</span>
                  <br />
                </card>
              </div>

              <div class="col-md-6">
                <card style="height: 300px;">
                  <form class="form-horizontal">
                    <h4 slot="header" class="card-title">Parametros</h4>
                    <div class="row">
                      <label class="col-md-3 col-form-label">Vel. Max.</label>
                      <div class="col-md-8">
                        <fg-input v-if="switchTrip.velocidad" placeholder="km / h" v-model="vmax" ></fg-input>
                        <fg-input v-else disabled placeholder="km / h" v-model="vmax" ></fg-input>
                      </div>

                      <label class="col-md-3 col-form-label">Tolerancia</label>
                      <div class="col-md-8">
                        <fg-input v-if="switchTrip.velocidad" placeholder="Minutos" style="margin-bottom: 24%;" v-model="tol" ></fg-input>
                        <fg-input v-else placeholder="Minutos" disabled style="margin-bottom: 24%;" v-model="tol" ></fg-input>
                      </div>
                    </div>
                  </form>
                </card>
              </div> <!-- col-md-6 -->
              <div style="margin: auto; margin-top: 2%;">
                <p-button type="success" @click="downloadXls()">
                  <i slot="label" class="nc-icon nc-check-2"></i>
                  Descargar
                </p-button>
                <p-button type="danger" @click="cancelSweet()">
                  <i slot="label" class="nc-icon nc-simple-remove"></i>
                  Cancelar
                </p-button>
              </div>
            </div> <!-- class="row" -->
          </div> <!-- class="card" -->
        `,
        computed: {
          ...mapState(["vehiculosSeleccionados", "dateFrom", "dateTo"])
        },
        data() {
          return {
            switchTrip: {
              recorridos: false,
              eventos: false,
              velocidad: false
            },
            vmax: "",
            tol: ""
          };
        },
        methods: {
          cancelSweet() {
            swal.close();
          },
          downloadXls() {
            let urlxls =
              ConfigParams.API_REP_URL +
              "index.php?veh=" +
              this.vehiculosSeleccionados[0].pat +
              "&from=" +
              this.formatDate(this.dateFrom) +
              "&to=" +
              this.formatDate(this.dateTo);

            if (this.switchTrip.recorridos) urlxls += "&trip=yes";
            else urlxls += "&trip=no";

            if (this.switchTrip.eventos) urlxls += "&event=yes";
            else urlxls += "&event=no";

            if (!this.switchTrip.velocidad) urlxls += "&vel=no";
            else {
              urlxls +=
                "&vel=yes" + "&veltol=" + this.tol + "&velmax=" + this.vmax;
            }

            urlxls += "&xval=" + ConfigParams.INDEX_KEY;
            window.open(urlxls, "_blank");
            this.cancelSweet();
          },
          formatDate(actualDate) {
            var newdate = new Date(actualDate);
            return newdate.toISOString().substring(0, 10);
          }
        },
        components: {
          [Button.name]: Button,
          Card,
          PSwitch
        }
      });
      new Vue({
        store,
        computed: {
          ...mapState(["dateFrom", "dateTo", "vehiculosSeleccionados"])
        },
        data() {
          return {
            hola: "hola"
          };
        },
        el: "#modal",
        beforeCreate: () => {
          swal({
            background: "#e9ecef",
            titleText: "Descarga de Reportes",
            showCancelButton: false,
            showConfirmButton: false,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Descargar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            width: 800,
            html: '<div id="modal"><my-comp></my-comp></div>'
            // }).then(function(result){
            //   if (result.value) {
            //     this.downloadXls();
            //   }
          });
        }
      });
    }
  }
};
</script>


<style>
  tbody > tr {
    cursor:pointer
   }

  .weekend-day {
    /* background: red !important; */
    color:red !important;
  }

 .no-hover:hover > td {
  /* background-color: initial !important; */
  background-color: #c32e2e !important;
}
</style>

<style scoped>
.card .card-content, .card-body{
    padding: 0px 15px 0px 15px;
    box-shadow: 0 6px 10px -4px rgba(40, 40, 40, 0.7);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
}
.form-buttons.report-buttons {
  margin: 10px 10px;
  margin-top: 40px;
}
.extended-forms {
  padding: 10px;
}
.content {
  height: 100%;
}
.etiquetas {
  text-transform: capitalize;
  font-weight: 400;
  color: #9a9a9a;
  font-size: 12px;
}

.totales {
  border: 2px solid;
  border-color: #ec3f30;
}

/* .no-hover:hover > td {
  background-color: initial !important;
} */

@import "../../../assets/css/vue-multiselect.min.css";
</style>

